import { useEffect } from 'react'
import { type Theme, ThemeProviderContext } from './theme-context'

export { useTheme } from './theme-context'
export type { Theme } from './theme-context'

// Light mode is retired: the app is dark-only. Stored preferences (user settings, the old
// `vite-ui-theme` localStorage key) are ignored rather than migrated, so a legacy 'light'
// value can never resurface.
const FORCED_THEME: Theme = 'dark'

function applyThemeClass(): void {
	const root = window.document.documentElement

	root.classList.remove('light')
	root.classList.add('dark')
}

type ThemeProviderProps = {
	children: React.ReactNode
}

const themeValue = { theme: FORCED_THEME }

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
	// index.html ships the class so first paint is already dark; this re-asserts it in case
	// anything strips it at runtime.
	useEffect(() => {
		applyThemeClass()
	}, [])

	return (
		<ThemeProviderContext.Provider {...props} value={themeValue}>
			{children}
		</ThemeProviderContext.Provider>
	)
}

/**
 * Effective 'dark' | 'light' variant used for asset selection (logo, favicon, map styles).
 * Always dark — kept as a function so callers reading `theme` stay uniform.
 */
export function resolveEffectiveTheme(_theme: Theme): 'dark' | 'light' {
	return 'dark'
}
